import { useQuery } from '@apollo/client'
import { useFeedbacker } from 'app/lib/contexts/Feedbacker'
import useTranslation from 'app/lib/hooks/useTranslation'
import { INCIDENT_REPORTING_ENABLED_QUERY } from 'app/queries/Incidents'

import ReportForm from './ReportForm'
import { IncidentSubject } from './typing'

// Apollo's own useQuery: the app wrapper toasts every error, and a failed flag check means "off".
export const useIncidentReportingEnabled = (): boolean | undefined => {
  const { data, loading } = useQuery<{ incidentReportingEnabled: boolean }>(
    INCIDENT_REPORTING_ENABLED_QUERY
  )

  return loading ? undefined : !!data?.incidentReportingEnabled
}

export const useReportIncident = () => {
  const { t } = useTranslation()
  const { drawerfy } = useFeedbacker()

  return (subject?: IncidentSubject) =>
    drawerfy.open({
      title: t({ id: 'record.incident.report.title' }),
      drawerKey: 'report-incident',
      width: 500,
      singleDrawer: true,
      content: <ReportForm subject={subject} onSuccess={() => drawerfy.closeAll()} />
    })
}
